
import { truncateString } from "@/filters";
import { BaseDeviceSummary } from "@/types/sv-data/system-view/SetupSummary";
import { Component, Prop, Vue } from "vue-property-decorator";
import { FeaturesList } from "@/store/types";
import { Getter } from "vuex-class";
import { get } from "lodash";
import customFieldsApi from "@/services/api.customField.service";
import { CustomFieldValues, CustomFieldTableTypes } from '@/store/custom-fields/types';
import CustomDefinedFieldsDisplay from '../custom-fields/CustomDefinedFieldsDisplay.vue';

@Component({
	components: {
		"custom-fields-display": CustomDefinedFieldsDisplay
	},
	filters: { truncateString }
})
export default class SystemOverview extends Vue {
	@Prop({required: true})
	private value: BaseDeviceSummary;

	@Prop({required: false, default: false, type: Boolean})
	private showLastAlarm: boolean;

	@Getter("getFeaturesList") featuresList: FeaturesList;

	private customFieldObjectValues: CustomFieldValues[] = [];
	private deviceCustomFieldTableType: number = CustomFieldTableTypes.Device;

	private async mounted(): Promise<void> {
		if (this.isCustomFieldDeviceEnabled) {
			try
			{
				this.customFieldObjectValues = await customFieldsApi.retrieveCustomFieldsForObject(
					this.value.deviceID,
					CustomFieldTableTypes.Device
				);
			}
			catch (e)
			{
				console.error(
				"Failed to get Custom Fields for object with objectId: " + this.value.deviceID);
				this.customFieldObjectValues = [];
			}
		}
		else
		{
			this.customFieldObjectValues = [];
		}
	}

	private get isCustomFieldDeviceEnabled(): boolean {
		return get(this.featuresList, ["CustomFields", "Devices"]);
	}

	private get customFieldsAvailable(): boolean {
		return !!this.customFieldObjectValues &&
			this.customFieldObjectValues?.length > 0
	}
}
